import { AxiosError } from "axios";

export const getStatusCode = (error: AxiosError): number | null => {
	const statusCode = +(error?.response?.status as number);

	return statusCode ?? null;
};
